import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'rcp-modal-content',
  template: ` <ng-content></ng-content> `,
  imports: [FontAwesomeModule],
  styles: `
    :host-context(.content-scrollable) {
      overflow-y: auto;
    }

    :host {
      display: flex;
      flex-direction: column;
      gap: var(--section-spacing-between);
      padding: var(--rcp-modal-content-padding, var(--modal-padding));
      /* override default padding, modal-header has full padding */
      padding-top: var(--rcp-modal-content-padding-top, 0);
      background: var(--rcp-modal-content-background, initial);

      flex-grow: 1;

      --legacy-default-padding: 0;
      --section-after-border-display: none;
    }

    ::ng-deep {
      section section {
        /* TODO Restyle add padding back to inner sections, since they are removed from the first level */
        /* when sections are redone, there should be no nested sections anymore */
        --legacy-default-padding: 30px;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalContentComponent {}
